<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import type { ITheHeaderMobileMenuEmits, ITheHeaderMobileMenuProps } from '@modules/header/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { TRANSLATION_GROUP_HEADER } from '@modules/header/constants';
import TheLanguageSelector from '@modules/i18n/components/TheLanguageSelector/TheLanguageSelector.vue';
import { useCurrentNamespace } from '@modules/permissions/composables';

defineProps<ITheHeaderMobileMenuProps>();

const emit = defineEmits<ITheHeaderMobileMenuEmits>();
const route = useRoute();

const { isAdminNamespace, isAffiliateNamespace } = useCurrentNamespace();

const isVisible = ref(false);

watch(() => route, () => {
  isVisible.value = false;
});
</script>

<template>
  <div v-data-qa-auto-id="'TheHeaderMobileMenu'">
    <VIconButton
      icon="pi-user"
      text-color="white"
      @click="isVisible = true"
    />
    <PSidebar
      v-model:visible="isVisible"
      :show-close-icon="false"
      :pt="{ root: 'h-48', header: 'p-0', content: 'p-4' }"
      position="bottom"
      block-scroll
    >
      <div
        class="mb-4 flex w-full flex-col items-center border-b pb-4 text-xl xs:flex-row"
        :class="isAdminNamespace ? 'justify-center' : 'justify-between'"
      >
        <span class="py-2">{{ userEmail }}</span>

        <span v-if="isAffiliateNamespace && userBalance">
          <RouterLink
            class="py-2 font-medium"
            :to="balanceRoute"
          >
            <span>{{ $getTranslation(TRANSLATION_GROUP_HEADER, 'BALANCE_IN_HEADER') }}&nbsp;</span>
            <span class="whitespace-nowrap py-2 font-bold text-primary">{{ userBalance }}</span>
          </RouterLink>
        </span>
      </div>
      <div class="flex w-full items-center justify-between">
        <TheLanguageSelector
          class="m-0 flex-1"
          is-dark
          is-mobile-menu
        />
        <div class="flex flex-1 justify-center">
          <VIconButton
            icon="pi-cog"
            :to="settingsRoute"
          />
        </div>
        <div class="flex flex-1 justify-end">
          <VIconButton
            icon="pi-sign-out"
            @click="emit('sign-out')"
          />
        </div>
      </div>
    </PSidebar>
  </div>
</template>
